import { render, staticRenderFns } from "./ArchiveApplications.vue?vue&type=template&id=6f6b5cb4&scoped=true&"
import script from "./ArchiveApplications.vue?vue&type=script&lang=js&"
export * from "./ArchiveApplications.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveApplications.vue?vue&type=style&index=0&id=6f6b5cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b5cb4",
  null
  
)

export default component.exports